// extracted by extract-css-chunks-webpack-plugin
module.exports = {"videoContainer":"videoContainer-3XYyNrsH","containerMargin":"containerMargin-3dikTDrF"};